<template>
    <section class="acclaro-search-bar active">
        <!-- v-bind:class="{active: isActive}" -->
        <div class="as-container">
            <div class="as-searchbar">
                <div>
                    <acclaro-select :selected="defaultSelectedFilter" v-on:item-selected="onSelectChange"
                                    v-bind:items="resultTypes"/>
                </div>
                <div class="as-content" v-click-outside="hideDropdown">
                    <input class="as-input" v-on:keyup.enter="goToOrders" v-on:input="debounceSearch(searchString);"
                           v-model.trim="searchString" v-bind:placeholder="inputPlaceholder" type="input" maxlength="255">
                    <div class="as-dropdown">
                        <ul class="as-results" v-show="results.rows.length && dropdownVisible && showDropdown">
                            <li class="as-result-item" v-for="result in results.rows">
                                <a v-bind:href="'/orders/view/' + result.orderid"><span class="ellipsis">{{result.orderid}} - {{result.name}}</span></a>
                            </li>
                        </ul>
                    </div>
                </div>
                <button v-bind:disabled="!searchString.length" class="as-search-btn" v-on:click="goToOrders">
                    <Magnify :size="20"/>
                </button>
            </div>
        </div>
    </section>

</template>

<script>
  import './style.scss';
  import ClickOutside from 'vue-click-outside';
  import {Magnify} from '../icons.js';
  import {findKey, uniqBy} from 'lodash';
  import debounce from 'lodash/debounce';

  const searchHttp = (type, query) => {
    return new Promise((resolve) => {
      axiosCache.get(`/search/${type.toLowerCase()}`, {
        params: {
          query
        }
      })
        .then((response) => {
          let {results, count} = response.data;

          resolve({results, count, type});
        });
    });
  };

  /*const iconTypes = {
    File: faFileAlt,
    Comment: faComments,
    Order: faClipboard,
    Tags: faTags
  };*/

  export default {
    props: {

      showDropdown: {
        type: Boolean,
        default: true
      },

      selectedFilterKey: {
        type: String,
        default: 'all'
      },

      searchQuery: {
        default: '',
        type: String
      },

      placeholder: {
        default: 'Search Order Details...',
        type: String
      },

      url: {
        type: String,
        default: function () {
          let {protocol, pathname, host} = window.location;

          return protocol + host + pathname;
        }
      },

      async: {
        type: Boolean,
        default: true
      }
    },

    watch: {

      searchQuery (val) {
        //the user cleared the search
        if (!val) {
          this.searchString = '';
          this.inputPlaceholder = this.placeholder;
        }
      },

      selectedFilterKey (val) {
        this.defaultSelectedFilter = this.getSelectedFilter(this.selectedFilterKey, this.resultTypes);
      },
    },

    created () {
    },

    methods: {

      updateFilters (selectedFilter) {
        let {list_title: title, key} = selectedFilter;

        this.search(this.searchString, {title, key});
      },

      hideDropdown () {
        this.dropdownVisible = false;
      },

      /**
       * Called when user updates the search input
       *
       * @param searchString String
       * @param debounceTime Integer - used to modify the debounce time
       * on the parent component (if any is set)
       */
      onSearch (searchString, debounceTime) {
        if (searchString == this.lastSearchString && !debounceTime) return;

        this.search(searchString);
        this.lastSearchString = searchString;
        this.$emit('update:searchQuery', searchString, debounceTime);
      },

      getSelectedFilter (selectedFilterKey, resultTypes) {
        let type = findKey(resultTypes, function (chr) {
          return chr.id === selectedFilterKey;
        });

        //capitalize first letter
        //@TODO
        type = type.charAt(0).toUpperCase() + type.slice(1);

        return {
          type,
          name: resultTypes[type].type,
          id: resultTypes[type].id
        };
      },

      setResultType (type) {

        if (!type) {
          //if current available filters are

          let selectedType = this.selectedFilter;

          //check if the currently set filter type
          //is an available filter
          let hasCurrentType = this.resultTypes.find(type => type.selected && type.type == selectedType);

          //if it is than keep it selected
          if (hasCurrentType) return this.setResultType(hasCurrentType.type);

          //otherwise set it to all or the first available filter
          if (this.selectedFilterCount > 1) {
            this.setResultType('All');
          }
          else {
            this.setResultType(this.resultTypes.find(type => type.selected).type);
          }

          return;
        }

        this.selectedFilter = type;
      },

      goToOrders ($event) {
        let filterBy = 0;
        let {searchString, resultTypes} = this;

        if (this.async) return this.onSearch(searchString, 100);

        try {
          filterBy = resultTypes[this.selectedFilter].id;
        }
        catch (e) {
          console.error(e);
        }

        let href = `/orders/details?search=${searchString}&filter-by=${filterBy}`;

        window.location.href = href;
      },

      reset () {
        this.resultsCount = 0;
        this.searchResults.length = 0;
        this.searchString = "";
      },

      onSelectChange (item) {
        this.selectedFilter = item.type;

        if (this.searchString.length) {
          this.search(this.searchString);
        }

        this.inputPlaceholder = this.getItemPlaceholder(item);

        this.$emit('filter-selected', item);

        //this.setResultType();
      },

      resultTypeCount (type) {
        if (type == 'All') return this.searchResults.length;

        return this.searchResults.filter(result => result.type == type).length;
      },

      getIcon (type) {
        return iconTypes[type] || faClipboard;
      },

      getItemPlaceholder (item) {
        return this.resultTypes[item.type].placeholder;
      },

      search (query) {
        if (this.showDropdown === false) return;

        let promises = [];
        let selectedType = this.selectedFilter;

        for (let type in this.resultTypes) {
          let result = this.resultTypes[type];

          if (
            (selectedType == 'All' && type !== 'All')
            || (selectedType == type && type !== 'All')
          ) {
            promises.push(searchHttp(type, query));
          }
        }

        Promise.all(promises)
          .then((results) => {
            let searchResults = [];
            let totalResults = 0;

            results.forEach((item) => {
              let {type, count, results: rs} = item;
              let items = rs.map(x => Object.assign({}, x, {type}));

              searchResults = searchResults.concat(items);
              totalResults += count;
            });

            searchResults = uniqBy(searchResults, 'orderid');

            this.resultsCount = totalResults;
            this.searchResults = searchResults;
            this.dropdownVisible = true;
          });
      }
    },

    computed: {

      options () {
        return {
          templates: {
            //comment: 'comment'
          }
        };
      },

      activeOptions () {
        return this.resultTypes.filter(item => item.selected);
      },

      //check wether all filters have been selected
      isAllSelected () {
        return this.resultTypes.find(result => result.type == 'All').selected;
      },

      showAllFilters () {
        return this.resultTypes.find(result => result.type == 'All').selected;
      },

      selectedFilterCount () {
        return this.resultTypes.filter(result => result.selected && result.type !== 'All').length;
      },

      results () {
        const isAll = this.selectedFilter == 'All';

        let rows = this.searchResults.filter(result => isAll || result.type == this.selectedFilter);

        let headers = [];

        if (rows.length) {
          headers = Object.keys(rows[0]).map(name => name);
        }

        return {rows, headers};
      }
    },

    components: {
      Magnify
    },

    directives: {
      ClickOutside
    },

    data () {

      let resultTypes = {
        /*All: {
          type: 'All',
          id: 0
        },*/
        All: {
          type: 'All',
          icon: 'Receipt',
          placeholder: 'Search All...',
          id: 'all'
        },
        Orders: {
          type: 'Details',
          icon: 'Receipt',
          placeholder: 'Search Order Details...',
          id: 'details'
        },
        Comments: {
          type: 'Comments',
          icon: 'MessageText',
          placeholder: 'Search Comments...',
          id: 'comments'
        },
        Files: {
          type: 'File Names',
          placeholder: 'Search File Names...',
          icon: 'File',
          id: 'filenames'
        }
      };

      let defaultSelectedFilter = this.getSelectedFilter(this.selectedFilterKey, resultTypes);

      return {

        searchString: this.searchQuery,

        dropdownVisible: false,

        isActive: false,

        lastSearchString: '',

        inputPlaceholder: this.placeholder,

        searchResults: [/*{ orderid, name, date, status, statusColor, user, type }*/],

        resultTypes: resultTypes,

        selectedFilter: defaultSelectedFilter.type,

        debounceSearch: debounce(this.onSearch, 1000),

        defaultSelectedFilter

        /*resultTypes: [{
          type: 'All',
          selected: true
        },{
          type: 'Order Details',
          selected: false,
          icon: ['far', 'clipboard']
        },{
          type: 'Comments',
          selected: false,
          icon: ['far', 'comments']
        },{
          type: 'File Names',
          selected: false,
          icon: ['far', 'file-alt']
        }]*/
      };
    }
  };
</script>
